import { Icon } from 'components/UI/Icons';
import { Svgs } from 'environment';
import { PropsWithChildren } from 'react';
import { Link } from 'react-router-dom';
import { Skeleton } from './Skeleton';
import clsx from 'clsx';

interface Props {
	title: string;

	breadCrumbs: {
		title?: string;
		url: string;
	}[];
}

export const EntryHeader = ({ title, breadCrumbs, children }: PropsWithChildren<Props>) => {
	return (
		<div
			className={clsx(
				'bg-gray-100 p-4 md:px-10 flex items-center justify-between fixed top-0 right-0 left-0 z-40 h-[60px]'
			)}
		>
			<div className="flex items-center">
				{breadCrumbs && (
					<div className="hidden md:flex">
						{breadCrumbs.map((breadCrumb, index) => (
							<div key={index} className="flex items-center gap-2">
								<Link
									className="hover:underline max-w-[200px] overflow-hidden"
									to={breadCrumb.url}
								>
									{breadCrumb.title ? (
										<p
											className="text-xl font-semibold truncate"
											title={breadCrumb.title}
										>
											{breadCrumb.title}
										</p>
									) : (
										<Skeleton className="h-14 w-96" />
									)}
								</Link>

								<Icon svg={Svgs.ChevronRight} className="mt-1" />
							</div>
						))}
					</div>
				)}

				<p className="text-xl font-semibold">{title}</p>
			</div>

			{children}
		</div>
	);
};
